import { render } from "./Capitalize.vue?vue&type=template&id=6cfbcec2"
import script from "./Capitalize.vue?vue&type=script&lang=js"
export * from "./Capitalize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__